import React, { useCallback, useRef, useState } from "react";
import ReserveFirstHalf from "./ReserveCountFirsHalf";
import arrowLeft from  "../../../../assets/img/dashboard/arrow-left.svg"
import arrowRight from  "../../../../assets/img/dashboard/arrow-right.svg"
import ReserveCountsecondHalf from "./ReserveCountsecondHalf";
import PersianNumber from "../../../shared/PersianNumber";


export function ReserveCounts({ StatisticInfo }) {
const [firsthalf, setfirsthalf] = useState(true)
  return (
    <div className="ReserveCounts">
      <div className="d-flex-space md:flex-row flex-col mb-[47px]">
        <div className="d-flex gap-[24px]">
          <h3 className="UserStatics--h3">تعداد رزرو</h3>
          <div className="d-flex gap-[8px]">
            <div className="circle-green" />
            <div className="legande-text">
              رد شده : <span><PersianNumber number={StatisticInfo.count_failed_reserve} /></span>
            </div>
          </div>
          <div className="d-flex gap-[8px]">
            <div className="circle-orang" />
            <div className="legande-text">
              تایید شده : <span><PersianNumber number={StatisticInfo.count_successful_reserve} /></span>
            </div>
          </div>
        </div>
      <div className="flex gap-[20px] self-end mt-[20px] md:mt-[0]" >
        <div className="flex gap-[20px]">
          <button  onClick={()=>setfirsthalf(true)} className="ReserveCounts--arrow ">
           <img src={arrowRight}/>

          </button>
          <button onClick={()=>setfirsthalf(false)} className="ReserveCounts--arrow">
            <img src={arrowLeft}/>

          </button>
        </div>
      <div className="gray-bg">ماهیانه</div>
      </div>
      </div>
      <div>
        
        <div>
          {
             firsthalf ?
             <ReserveFirstHalf StatisticInfo={StatisticInfo} />:
             <ReserveCountsecondHalf StatisticInfo={StatisticInfo} />
          }
        </div>
      </div>
    </div>
  );
}

export default ReserveCounts;
